import { render } from "./ticheng-form.vue?vue&type=template&id=30bb1b8a&scoped=true"
import script from "./ticheng-form.vue?vue&type=script&lang=js"
export * from "./ticheng-form.vue?vue&type=script&lang=js"

import "./ticheng-form.vue?vue&type=style&index=0&id=30bb1b8a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bb1b8a"]])

export default __exports__